export default "__VITE_ASSET__78db3a48__"